<p-dialog
   header="Add a New Code"
   [modal]="true"
   [(visible)]="_showDialog"
   (onHide)="showDialog.set(false)"
   [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
   [style]="{ width: '50vw' }">
   <form
      #newCodeForm="ngForm"
	  class="mt-0 mr-3 mb-4 ml-3" >
      <div class="form-group">
         <label class="form-label">Is this a new item or service?</label>
         <div class="form-check form-check-inline ml-2">
            <p-radiobutton
               name="newProductType"
               value="1"
               inputId="newProductType1"
               [(ngModel)]="newProductType"
               [required]="true"
               class="form-check-input" />
            <label
               class="form-check-label"
               for="newProductType1">
               Item
            </label>
         </div>
         <div class="form-check form-check-inline">
            <p-radiobutton
               name="newProductType"
               value="2"
               inputId="newProductType2"
               [(ngModel)]="newProductType"
               [required]="true"
               class="form-check-input" />
            <label
               class="form-check-label"
               for="newProductType2">
               Service
            </label>
         </div>
      </div>
      <div class="form-group">
         <label
            for="newProductCode"
            class="form-label">
            What is the new code in your PIMS?
         </label>
         <input
            vcInput
            id="newProductCode"
            name="newProductCode"
            required="true"
            [(ngModel)]="newProductCode" />
      </div>
      <div class="form-group">
         <label
            for="newProductName"
            class="form-label">
            What is the name of your new product?
            <i>Hint: copy and paste product name if possible</i>
         </label>
         <input
            vcInput
            id="newProductName"
            name="newProductName"
            [required]="true"
            [(ngModel)]="newProductName" />
      </div>
      <div class="form-group">
         <label
            for="codeSearch"
            class="form-label">
            Please select new code from list of central codes
         </label>
         <p-autocomplete
            [hidden]="!_showDialog"
            name="vcProduct"
            [required]="!cantFindCode"
            [(ngModel)]="vcProduct"
            [suggestions]="searchResults"
            (completeMethod)="onVcProductSearch($event.query)"
            optionLabel="vcProductDescription"
            forceSelection="true"
            [appendTo]="_showDialog ? 'body' : undefined"
            scrollHeight="50vh"
            fluid="true" />
         <!-- <p-iconfield>
            <p-inputicon styleClass="pi pi-search" />
            <input
               pInputText
               id="codeSearch"
               (keyup)="onCodeSearch($event.target.value)"
               class="form-control"
               autocomplete="off" />
            <p-inputicon
               *ngIf="isSearching"
               styleClass="pi pi-spin pi-spinner" />
         </p-iconfield> -->
      </div>
      <!-- <div class="d-flex">
         <ul class="w-full">
            <li *ngFor="let product of searchResult$ | async">
               {{ product.title }}
            </li>
         </ul>
      </div> -->
      <div class="form-group d-flex">
         <label class="form-label mr-3">Can't find code</label>
         <p-toggleswitch
            [(ngModel)]="cantFindCode"
            name="cantFindCode" />
      </div>

      <ng-container *ngIf="!!vcProduct?.vcProductDescription || cantFindCode">
         <ng-container *ngIf="!cantFindCode">
            <div class="form-group">
               <label class="form-label">Is this a perfect match for your new code?</label>
               <div class="form-check form-check-inline ml-2">
                  <p-radiobutton
                     name="isPerfect"
                     value="yes"
                     inputId="isPerfectYes"
                     [(ngModel)]="isPerfect"
                     [required]="!cantFindCode"
                     class="form-check-input" />
                  <label
                     class="form-check-label"
                     for="isPerfectYes">
                     Yes
                  </label>
               </div>
               <div class="form-check form-check-inline">
                  <p-radiobutton
                     name="isPerfect"
                     value="no"
                     inputId="isPerfectNo"
                     [(ngModel)]="isPerfect"
                     [required]="!cantFindCode"
                     class="form-check-input" />
                  <label
                     class="form-check-label"
                     for="isPerfectNo">
                     No
                  </label>
               </div>
            </div>
            <div
               class="form-group"
               *ngIf="isPerfect == 'no'">
               <label
                  for="whyNotPerfect"
                  class="form-label">
                  Please describe why this standard code is not a perfect match
               </label>
               <textarea
                  class="form-control"
                  rows="3"
                  cols="30"
                  id="whyNotPerfect"
                  name="whyNotPerfect"
                  pTextarea
                  [required]="!cantFindCode && isPerfect == 'no'"
                  [(ngModel)]="whyNotPerfect"></textarea>
            </div>
         </ng-container>
         <ng-container>
            <div
               class="form-group"
               *ngIf="cantFindCode">
               <label
                  for="descCantFind"
                  class="form-label">
                  Please describe what this code is and how you will use it in your practice
               </label>
               <textarea
                  class="form-control"
                  rows="3"
                  cols="30"
                  id="descCantFind"
                  name="descCantFind"
                  pTextarea
                  [required]="cantFindCode"
                  [(ngModel)]="descCantFind"></textarea>
            </div>

            <div class="form-group">
               <label class="form-label">Do you offer a similar code already?</label>
               <div class="form-check form-check-inline ml-2">
                  <p-radiobutton
                     name="hasSimilar"
                     value="yes"
                     inputId="hasSimilarYes"
                     [required]="true"
                     [(ngModel)]="hasSimilar"
                     class="form-check-input" />
                  <label
                     class="form-check-label"
                     for="hasSimilarYes">
                     Yes
                  </label>
               </div>
               <div class="form-check form-check-inline">
                  <p-radiobutton
                     name="hasSimilar"
                     value="no"
                     inputId="hasSimilarNo"
                     [required]="true"
                     [(ngModel)]="hasSimilar"
                     class="form-check-input" />
                  <label
                     class="form-check-label"
                     for="hasSimilarNo">
                     No
                  </label>
               </div>
            </div>
            <ng-container *ngIf="hasSimilar == 'yes'">
               <div class="form-group">
                  <label
                     for="similarProduct"
                     class="form-label">
                     What is that code?
                  </label>
                  <p-autocomplete
                     [(ngModel)]="similarProduct"
                     name="similarProduct"
                     id="similarProduct"
                     [required]="hasSimilar == 'yes'"
                     forceSelection="true"
                     [suggestions]="productSearchResults"
                     (completeMethod)="onProductSearch($event.query)"
                     [optionLabel]="getProductLabel"
                     [appendTo]="_showDialog ? 'body' : undefined"
                     scrollHeight="75vh"
                     fluid="true" />
               </div>
               <div class="form-group">
                  <label
                     for="similarCodeDifference"
                     class="form-label">
                     What is different about new code?
                  </label>
                  <input
                     vcInput
                     id="similarCodeDifference"
                     name="similarCodeDifference"
                     [required]="hasSimilar == 'yes'"
                     [(ngModel)]="similarCodeDifference" />
               </div>
               <div class="form-group">
                  <label
                     for="oldCost"
                     class="form-label">
                     If you are switching supplies, what is the old cost?
                  </label>
                  <input
                     vcInput
                     id="oldCost"
                     name="oldCost"
                     type="number"
                     [required]="hasSimilar == 'yes' && !oldCostNA"
                     min="0"
                     step="0.01"
                     [(ngModel)]="oldCost"
                     [disabled]="oldCostNA" />
				  <input
                     type="checkbox"
                     [(ngModel)]="oldCostNA"
                     name="oldCostNA"
					 class="ml-3"
                     (change)="onOldCostNAChecked()" />
                  <label
                     class="form-check-label"
                     for="oldCostNA">
                     &nbsp;&nbsp;N/A
                  </label>
               </div>
            </ng-container>
            <ng-container *ngIf="!!hasSimilar">
               <div
                  class="form-group"
                  *ngIf="newProductType() == 1">
                  <label
                     for="productLink"
                     class="form-label">
                     What is the link to the source item in your purchasing platform?
                  </label>
                  <input
                     vcInput
                     id="productLink"
                     name="productLink"
                     [required]="true"
                     [(ngModel)]="productLink" />
               </div>
               <div class="form-group">
                  <label class="form-label">Will you charge a fee? If so, what?</label>
                  <div class="form-check form-check-inline ml-2">
                     <p-radiobutton
                        name="hasFee"
                        value="yes"
                        inputId="hasFeeYes"
                        [(ngModel)]="hasFee"
                        [required]="true"
                        class="form-check-input" />
                     <label
                        class="form-check-label"
                        for="hasFeeYes">
                        Yes
                     </label>
                  </div>
                  <div class="form-check form-check-inline">
                     <p-radiobutton
                        name="hasFee"
                        value="no"
                        inputId="hasFeeNo"
                        [(ngModel)]="hasFee"
                        [required]="true"
                        class="form-check-input" />
                     <label
                        class="form-check-label"
                        for="hasFeeNo">
                        No
                     </label>
                  </div>
                  <input
                     vcInput
                     *ngIf="hasFee == 'yes'"
                     id="fee"
                     name="fee"
                     type="number"
                     min="0"
                     step="0.01"
                     [required]="hasFee == 'yes'"
                     [(ngModel)]="productFee" />
               </div>
               <div class="form-group">
                  <label class="form-label">Will you have quantity price breaks? If so what?</label>
                  <div class="form-check form-check-inline ml-2">
                     <p-radiobutton
                        name="hasQtyBreak"
                        value="yes"
                        inputId="hasQtyBreakYes"
                        [(ngModel)]="hasQtyBreak"
                        [required]="true"
                        class="form-check-input" />
                     <label
                        class="form-check-label"
                        for="hasQtyBreakYes">
                        Yes
                     </label>
                  </div>
                  <div class="form-check form-check-inline">
                     <p-radiobutton
                        name="hasQtyBreak"
                        value="no"
                        inputId="hasQtyBreakNo"
                        [(ngModel)]="hasQtyBreak"
                        [required]="true"
                        class="form-check-input" />
                     <label
                        class="form-check-label"
                        for="hasQtyBreakNo">
                        No
                     </label>
                  </div>
                  <input
                     *ngIf="hasQtyBreak == 'yes'"
                     id="qty"
                     name="qty"
                     [(ngModel)]="qtyBreak"
                     [required]="hasQtyBreak == 'yes'" />
               </div>
            </ng-container>
            <div class="form-group">
               <label
                  for="cost"
                  class="form-label">
                  What is your cost for this service/item?
               </label>
               <input
                  vcInput
                  id="cost"
                  type="number"
                  step="0.01"
                  name="cost"
                  min="0"
                  [required]="true"
                  [(ngModel)]="newCost" />
            </div>
         </ng-container>

         <div class="d-flex justify-content-end">
            <p-button
               label="Cancel"
               severity="secondary"
               class="mr-3"
               (onClick)="showDialog.set(false)" />
            <p-button
               label="Submit"
               [disabled]="!newCodeForm.valid"
               (onClick)="onSubmit()" />
         </div>
      </ng-container>
   </form>
</p-dialog>
